module.exports = __webpack_public_path__ + "media/application/images/demsoc/tiles/polychrome_1-5518101255698246c2d3991514aeac30.jpg";